// extracted by mini-css-extract-plugin
module.exports = {"table":"detail-backup_table_oGA__","label":"detail-backup_label_2hSB6","icon":"detail-backup_icon_2_ziS","downloadText":"detail-backup_downloadText_2MOcw"};